import { render } from "./Alerts.vue?vue&type=template&id=a182be2a&scoped=true&bindings={\"errors\":\"options\",\"messages\":\"options\"}"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"

import "./Alerts.vue?vue&type=style&index=0&id=a182be2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a182be2a"

export default script